import { createContext, useContext } from "react";
import { Role, type Me } from "../api/generated/model";

export type { Me };

// The current operator's identity + role, resolved once by RequireAuth from
// /v1/me and shared with the shell and the Users page.
export const CurrentUserContext = createContext<Me | null>(null);

export function useCurrentUser(): Me {
  const me = useContext(CurrentUserContext);
  if (!me) throw new Error("useCurrentUser must be used inside RequireAuth");
  return me;
}

const WRITE_ROLES: ReadonlySet<string> = new Set([Role.member, Role.superuser]);

/**
 * Viewers can inspect every operational view but cannot trigger mutations. An
 * allowlist, so an unknown role fails closed to read-only, matching the API.
 */
export function canWrite(me: Pick<Me, "role">): boolean {
  return WRITE_ROLES.has(me.role);
}

export function useCanWrite(): boolean {
  return canWrite(useCurrentUser());
}
